import { IDeprecatedUIState } from "../../../redux/modules/ui/reducer";
import AbstractTilesLayer from "../../AbstractTilesLayer";
import { getPrescanState, getAnyScanState } from "../../../redux/rootReducer";
import config from "../../../config";

export default class ElevationMapLayer extends AbstractTilesLayer {
  protected getTilesPath(state: any) {
    const scanState = getPrescanState(state);
    const anyScanState = getAnyScanState(state);

    if (!scanState.data && !anyScanState.data) {
      return null;
    }

    return (
      scanState.data?.elevationMapTilesPath ||
      anyScanState.data?.elevationMapTilesPath ||
      null
    );
  }

  protected shouldBeVisible(state: any) {
    const uiState: IDeprecatedUIState = state.deprecatedUi;
    return uiState.elevationMapIsVisible;
  }

  protected getLayerOptions() {
    return config.elevationMapLayerOptions;
  }
}
